import axios from 'axios';

const fetchBars = async (latitude = null, longitude = null, category = null) => {
    try {
        const token = localStorage.getItem('token'); // Substituindo AsyncStorage por localStorage

        // Se latitude e longitude forem fornecidos, envia via POST com body
        if (latitude !== null && longitude !== null) {
            const body = {
                latitude: latitude,
                longitude: longitude
            };
            
            // Adicionar categoria se fornecida
            if (category) {
                body.category = category;
            }
            
            const response = await axios.post(
                'https://apem.riderup.uk/api/seachBars',
                body,
                {
                    headers: { 
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } else {
            // Fallback: busca sem coordenadas (GET)
            const response = await axios.get('https://apem.riderup.uk/api/seachBars', {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data;
        }
    } catch (error) {
        console.error('Erro ao buscar bares:', error);
        return [];
    }
};

export default fetchBars;
